import api from "./api";
import { TaxSelection, TaxTreatmentSet } from "../models/TaxTreatment";

const digits = (v: string) => v.replace(/\D/g, "");

export const getTaxTreatments = async (ncm: string, country: string): Promise<TaxTreatmentSet> =>
  (await api.get("/api/catalog/tax-treatments", { params: { ncm: digits(ncm), country } })).data;

export const getTaxSelection = async (ncm: string, product: string, exporter: string, country: string): Promise<TaxSelection[]> =>
  (await api.get("/api/catalog/tax-selection", { params: { ncm: digits(ncm), product, exporter, country } })).data.selections ?? [];

export const saveTaxSelection = async (ncm: string, product: string, exporter: string, country: string, selections: TaxSelection[]) =>
  (await api.put("/api/catalog/tax-selection", { ncm: digits(ncm), product, exporter, country, selections })).data;
